import FullScreenLanguageSelect from './FullScreenLanguageSelect'
export default FullScreenLanguageSelect;